import React from 'react'

import { Formik } from 'formik'
import { connect } from 'react-redux'

import * as auth from 'store/ducks/auth.duck'

import * as AuthService from 'services/auth.service'
import * as AkdemicService from 'services/akdemic.service'

import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';

function Login(props) {
  const aniosOptions = React.useMemo(() => {
    const anioActual = new Date().getFullYear()
    const limiteAnios = anioActual - 10

    const output = []

    for (let i = anioActual + 1; i >= limiteAnios; i--) {
      output.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return output
  }, [])

  const loginFunction = React.useCallback((values, { setStatus, setSubmitting }) => {
    AuthService.login(values)
      .then(({ accessToken, flagAkdemic }) => {
        props.setToken(accessToken)
        if (flagAkdemic) {
          AkdemicService.obtenerToken({
            clientId: "akdemic",
            clientSecret: "Educacion2020"
          }).then(({ data }) => {
            props.setAkdemicToken(data.token)
            window.location.reload()
          }).catch((error) => {
            // El token Akdemic es OPCIONAL: si el API académico no responde (p. ej. no
            // configurado para este cliente), igual entramos a Contasoft con el token ya emitido.
            console.log(error)
            window.location.reload()
          })
        } else {
          window.location.reload()
        }
      })
      .catch(err => {
        if (err && err.data) {
          setStatus(err.data.message)
        } else {
          setStatus('Usuario y/o contraseña incorrecta.')
        }
        setSubmitting(false)
      })
  }, [props])

  const [showPassword, setShowPassword] = React.useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <Formik
        initialValues={{
          username: '',
          contrasena: '',
          anio: new Date().getFullYear()
        }}
        onSubmit={loginFunction}
      >
        {({ values, status, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form noValidate={true} autoComplete='off' className='kt-form' onSubmit={handleSubmit}>
            {status && (
              <div role='alert' className='alert alert-danger'>
                <div className='alert-text'>{status}</div>
              </div>
            )}

            <input
              type='text'
              name='username'
              id='username'
              className='zr-input zr-block login-input'
              placeholder='USUARIO'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.username}
              disabled={isSubmitting}
            />
            <div className='zr-input-password'>
              <input
                type={showPassword ? 'text' : 'password'}
                name='contrasena'
                id='contrasena'
                className='zr-input zr-block login-input'
                placeholder='CONTRASEÑA'
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contrasena}
                disabled={isSubmitting}
              />
              <button type='button' className='btn-showPassword' onClick={togglePasswordVisibility}>
                {showPassword ? <RiEyeOffFill /> : <RiEyeFill />}
              </button>
            </div>

            <select
              id='anio'
              name='anio'
              className='zr-select zr-block login-select'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.anio}
              disabled={isSubmitting}
            >
              {aniosOptions}
            </select>
            <button type='submit' className='zr-btn zr-btn-primary zr-block login-btn' disabled={isSubmitting}>
              INICIAR SESIÓN
            </button>
          </form>
        )}
      </Formik>
    </>
  )
}

export default connect(null, auth.actions)(Login)
